import { empressTitles } from './content'
import { Arrow } from './ui'

export default function CrownTitles() {
  return <div className="crown-and-titles">
    <figure className="empress-crown">
      <a className="empress-crown-artwork" href="/images/empress-crown.jpg" target="_blank" rel="noopener noreferrer" aria-label="ดูภาพมงกุฎ EMPRESS OF WELLNESS ขนาดเต็ม (เปิดแท็บใหม่)">
        <img src="/images/empress-crown-1254.webp" srcSet="/images/empress-crown-640.webp 640w, /images/empress-crown-1254.webp 1254w" sizes="(max-width: 960px) 90vw, 42vw" width="1254" height="1254" loading="lazy" decoding="async" alt="มงกุฎ EMPRESS OF WELLNESS 2026 ประดับอัญมณีโทนทอง" />
      </a>
      <figcaption><span>THE EMPRESS CROWN</span><a href="/images/empress-crown.jpg" target="_blank" rel="noopener noreferrer">ดูมงกุฎขนาดเต็ม <Arrow /><span className="sr-only"> (เปิดแท็บใหม่)</span></a></figcaption>
    </figure>
    <ol className="titles-list" aria-label="5 ตำแหน่งผู้ชนะ EMPRESS OF WELLNESS">
      {empressTitles.map((title, index) => <li key={title.name}>
        <span className="title-index">0{index + 1}</span>
        <div><p>{title.rank}</p><h3>{title.name}</h3></div>
        <span>{title.description}</span>
      </li>)}
    </ol>
  </div>
}
